import { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
// utils
import axios from 'axios';
import { isValidToken, setSession, setErrors, setUser } from '../utils/jwt';
import urls from '../url/urls';

// ----------------------------------------------------------------------

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  username: null
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user, username } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
      username
    };
  },
  LOGIN: (state, action) => {
    const { user, username } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
      username
    };
  },
  UPDATEPROFILE: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      user,
      isAuthenticated: true,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
    username: null
  }),
  REGISTER: (state, action) => {
    const { user, username } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
      username
    };
  }
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  changePassword: () => Promise.resolve(),
  updateProfile: () => Promise.resolve(),
  register: () => Promise.resolve()
});

AuthProvider.propTypes = {
  children: PropTypes.node
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');
        const user = window.localStorage.getItem('user');

        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);
          // const response = await axios.get('/api/account/my-account');
          // const { user } = response.data;
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user
            }
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null
            }
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
      }
    };

    initialize();
  }, []);

  const login = async (username, password) => {
    const url = `${urls.lelang}/signin`;
    const response = await axios.post(url, {
      username,
      password
    }).then((response) => {
      // alert(JSON.stringify(response.data));
      if (response.data.aktivasi == null) {
        console.log("Silahkan aktivasi Terlebih Dahulu");
        setErrors('Silahkan Aktivasi terlebih dahulu dari link yang Kami Berikan Pada Email Anda');
      } else {
      const { accessToken } = response.data.accessToken;
      const user = {
        displayName: response.data.nama,
        phoneNumber: response.data.hp,
        role: response.data.roles[0],
        id: response.data.id,
        divisi: response.data.divisi,
        email: response.data.email
      };
      window.localStorage.setItem('user', user);
      
      setSession(accessToken);
      setUser(user);
      dispatch({
        type: 'LOGIN',
        payload: {
          user
        }
      });
      setErrors('');
    }
    })
      .catch((error) => {
        console.log(error.response.data.message);
        setErrors(error.response.data.message);
      });;




  };

  const register = async (email, password, username, nama, role, hp) => {
    const url = `${urls.lelang}/signup`;
    const response = await axios
      .post(
        url,
        {
          username: `${username}`,
          nama: `${nama}`,
          email: `${email}`,
          password: `${password}`,
          hp: `${hp}`,
          role: ['mod']
        },
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        }
      )
      .then((response) => {
        const { accessToken, message } = response.data;
        console.info('Hasil Login');

        console.info(JSON.stringify(response.data));

        window.localStorage.setItem('accessToken', accessToken);
        setErrors('');
      })
      .catch((error) => {
        // alert(error.response.data.message);
        console.log(error.response.data.message);
        setErrors(error.response.data.message);
      });
  };

  const logout = async () => {
    setSession(null);
    dispatch({ type: 'LOGOUT' });
    window.localStorage.setItem('user', null);
  };

  const resetPassword = () => { };

    const changePassword = async (username, password) => {

    const url = `${urls.lelang}/changePass`;
    const response = await axios.post(url, {
      username,
      password
    }).then((response) => {
      setSession(null);
      dispatch({ type: 'LOGOUT' });
      setErrors('');
      window.localStorage.setItem('user', null);
    })
      .catch((error) => {
        console.log(error.response.data.message);
        setErrors(error.response.data.message);
      });


   };

  const updateProfile = async (email,nama, hp) => {
    const url = `${urls.lelang}/changeProfile`;
    const response = await axios.post(url, {
      email,
      nama,
      hp
    }).then((response) => {
      const user = {
        displayName: response.data.nama,
        phoneNumber: response.data.hp,
        role: response.data.roles,
        email: response.data.email
      };
      setSession(null);
      dispatch({ type: 'LOGOUT' });
      setErrors('');
      window.localStorage.setItem('user', null);

    })
      .catch((error) => {
        console.log(error.response.data.message);
        setErrors(error.response.data.message);
      });


   };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        register,
        resetPassword,
        changePassword,
        updateProfile
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
